import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-primary-950 px-4 text-center">
      <h1 className="pointer-events-none absolute bottom-0 select-none font-heading text-[10rem] font-black leading-none text-primary-900/60 md:text-[16rem]">
        404
      </h1>
      <div className="relative z-10 max-w-lg">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-lg bg-accent-500 font-heading text-2xl font-black text-foreground-950">
          朝
        </div>
        <h1 className="mt-6 font-heading text-2xl font-black text-background-50 md:text-3xl">
          页面走丢了
        </h1>
        <p className="mt-3 text-sm text-background-300">
          你访问的页面不存在或已被移除。当前路径：
          <span className="ml-1 break-all text-accent-400">{location.pathname}</span>
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-bold text-foreground-950 transition-colors hover:bg-accent-400"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/works"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-background-50/10"
          >
            浏览影视作品
          </Link>
        </div>
      </div>
    </div>
  );
}